"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: block;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  letter-spacing: 0.6px;\n  width: 100%;\n  color: ", ";\n\n  @media print, screen and (min-width: ", "px) {\n    display: flex;\n    flex-basis: auto;\n    width: auto;\n\n    &:after {\n      display: inline-block;\n      content: '|';\n      width: 3px;\n      height: 5px;\n      margin-left: 15px;\n      margin-right: 15px;\n    }\n\n    &:last-child:after {\n      display: none;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FooterItem = _styledComponents.default.li(_templateObject(), function (_ref) {
  var color = _ref.color;
  return color || _Constant.Color.DARK_GREY;
}, _Constant.Width.MD);

FooterItem.displayName = 'FooterItem';
var _default = FooterItem;
exports.default = _default;